import type { Observable } from 'rxjs';

import { ApiQuery } from '@apps/main/modules/api/shared/apiQuery';
import { camelCased } from '@apps/main/modules/api/shared/apiQuery.helper';

import { getAuthToken } from '@libs/cookie';

import type { MemberAuth } from '../../models/memberAuth';
import type { SemboUser } from '../../models/semboUser';

export class UserService {
  private apiQuery = new ApiQuery();

  public fetchSemboUser(): Observable<SemboUser> {
    const url = 'mvc/Members/GetMember';
    return this.apiQuery
      .getObservable<SemboUser>(url)
      .pipe(camelCased({ deep: true }));
  }

  public fetchMemberAuth(): Observable<MemberAuth> {
    const url = 'mvc/MemberAuth/GetMemberAuth';
    const token = getAuthToken();
    return this.apiQuery
      .getObservable<MemberAuth>(
        url,
        token ? { 'X-Sembo-Context': token } : undefined
      )
      .pipe(camelCased({ deep: true }));
  }
}
